import { isConnected } from "@stacks/connect";
import { fetchChallenge, postChallengeResponse } from "../auth";
import { address } from "bitcoinjs-lib";

const getProvider = () => {
    if ('phantom' in window) {
        const anyWindow = window;
        const provider = anyWindow.phantom?.bitcoin;

        if (provider && provider.isPhantom) {
            return provider;
        }
    }

    window.open('https://phantom.app/', '_blank');
};


export const loginWithPhantom = async () => {
    const provider = getProvider();
    console.log('provider', provider);
    if (!provider) {
        throw new Error('Phantom wallet not found');
    }

    try {
        const resp = await provider.requestAccounts();
        const address = resp.find((address) => address.purpose === 'payment')?.address;

        const challenge = await fetchChallenge(address);
        console.log("Challenge:", challenge);

        const signature = await signMessageWithPhantom({
            provider,
            address,
            message: challenge,
        });
        console.log("Signature:", signature);

        const response = await postChallengeResponse({
            address,
            message: challenge,
            signature,
        });
        if (!response.token) {
            throw new Error('No auth token received');
        }
        console.log("Response:", response.token);
        return {
            address,
            isConnected: true,
            token: response.token,
        };
    } catch (err) {
        throw err;
    }
};


export const getPhantomWalletAndProvider = async () => {
    try {
        const provider = getProvider();
        // Check if Phantom is installed
        if (!provider) {
            throw new Error('Phantom wallet not found');
        }
        const resp = await provider.requestAccounts();
        console.log('resp', resp);
        const wallet = resp.find((address) => address.purpose === 'payment');
        const address = wallet?.address;
        const publicKey = wallet?.publicKey;

        return {
            address,
            provider,
            publicKey,
        };
    } catch (error) {
        console.error('Error signing message with Phantom:', error);
        throw error;

    }
};

export const signMessageWithPhantom = async ({ provider, address, message }) => {
    const encodedMessage = new TextEncoder().encode(message);
    const { signature } = await provider.signMessage(address, encodedMessage);
    return uint8ArrayToBase64(signature);
};


function uint8ArrayToBase64(uint8Array) {
    return btoa(String.fromCharCode(...uint8Array));
}
